import { BUSINESS_TYPE } from '@/api/types';

import { i18n } from '@lingui/core';

export const getTitle = (
  index: number,
  recipientType: BUSINESS_TYPE | null
) => {
  const displayIndex = index + 1;
  const companyLabel = recipientType && recipientType !== BUSINESS_TYPE.JDG;

  return companyLabel
    ? `${i18n.t('Podaj dane reprezentanta spółki')} (${displayIndex})`
    : `${i18n.t('Podaj dane współwłaściciela')} (${displayIndex})`;
};
